<template>
  <client-only>
    <div v-if="projectHasLivechat && license" class="livechat-widget-container">
      <LiveChatWidget 
        :license="license" 
        @ready="onWidgetReady"
        @error="onWidgetError"
      />
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { LiveChatWidget } from '@livechat/widget-vue';
import { storeToRefs } from 'pinia';

const {
  public: { livechatParams },
} = useRuntimeConfig();

const livechatStore = useLivechatStore();
const { projectHasLivechat } = storeToRefs(livechatStore);

const license = computed(() => livechatParams?.license || '');

const onWidgetReady = () => {
  // Initialize chat after widget is ready with longer delay
  setTimeout(() => {
    livechatStore.addLiveChatScript();
  }, 2000); // Increased delay to ensure widget is fully loaded
};

const onWidgetError = (error: any) => {
  console.error('LiveChat Widget: error event fired', error);
};

// Initialize chat when component is mounted
onMounted(() => {
  if (projectHasLivechat.value && license.value) {
    // Widget will initialize itself and fire ready event
  }
});
</script>

<style scoped>
.livechat-widget-container {
  /* LiveChat widget manages its own positioning */
}
</style> 